import { FONT_FAMILIES } from '@dg-embalajes/catalog';
import { V46_FONT_PROFILES } from '@dg-embalajes/font-library';

export const EDITOR_TEXT_WEIGHT = 600 as const;

export interface EditorFontDescriptor {
  readonly family: string;
  readonly previewLabel: string;
  readonly requestedWeight: typeof EDITOR_TEXT_WEIGHT;
}

const previewByFamily = new Map(FONT_FAMILIES.map((font) => [font.family, font.previewLabel]));

export const EDITOR_FONT_MANIFEST: readonly EditorFontDescriptor[] = V46_FONT_PROFILES.map((font) => ({
  family: font.family,
  previewLabel: previewByFamily.get(font.family) ?? font.family,
  requestedWeight: EDITOR_TEXT_WEIGHT,
}));
